import React, { useState } from 'react'
import { useAxiosClient } from '../../contexts/Axios'
import { formatPlainDateDisplay } from '../../utils/DateUtils'

import {
    Card,
    CardContent,
    Typography,
    Button,
} from '@material-ui/core'
import { ButtonTooltip } from '../../components/Tooltips/BPMTooltips'
import { Description as DescriptionIcon } from '@material-ui/icons'
import { useLazyQuery, gql } from '@apollo/client'

import { BayphoneAcceptTermsDialog } from './BayphoneAcceptTermsDialog'

const GENERATE_DOWNLOAD_TOKEN = gql`
    query GenerateDownloadToken($resourceType: String!, $id: String!) {
        generateDownloadToken(resourceType: $resourceType, id: $id)
    }
`

const ActiveBayphones = (props) => {
    const { axiosClient } = useAxiosClient()

    const { bayphone, index, handleRefresh, t } = props

    const [generateToken] = useLazyQuery(GENERATE_DOWNLOAD_TOKEN, {
        onCompleted: (data) => {
            if (data?.generateDownloadToken) {
                window.location.assign(`${axiosClient.defaults.baseURL}/download/files/${data.generateDownloadToken}`)
            }
        }
    })

    const [openTermsDialog, setOpenTermsDialog] = useState(false)
    const [termsAccepted, setTermsAccepted] = useState(false)

    const handleShowAcceptTermsDialog = (type) => {
        setOpenTermsDialog(true)
    }

    const onCloseTermsDialog = () => {
        setOpenTermsDialog(false)
    }

    const formattedExpirationDate = formatPlainDateDisplay(bayphone?.expirationDate)

    return (
        <>
            <Card key={'actives'+index} component="form" noValidate style={{ marginBottom: 10, width: '100%' }}>
                <CardContent style={{ padding: 10 }}>
                    <Typography variant="subtitle1"><b>{t('Device Type')}: </b>{bayphone.deviceType.name}</Typography>
                    { (bayphone.state.name=="Pending") ?
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginLeft: 10, marginRight: 10 }}
                                onClick={e => handleShowAcceptTermsDialog()}
                            >
                                {t('Accept and Sign Terms')}
                            </Button>
                        : null
                    }
                    <div style={{ display: 'flex' }}>
                        <Typography style={{ marginTop: 10, marginRight: 10 }} variant="body2"><b>{t('Expiration date')}: </b>{formattedExpirationDate}</Typography>
                        <Typography style={{ marginTop: 10, marginRight: 10 }} variant="body2"><b>{t('Reason')}: </b>{bayphone.changeReason.name}</Typography>
                        <Typography style={{ marginTop: 10, marginRight: 10 }} variant="body2"><b>{t('State')}: </b>{bayphone.state.name}</Typography>
                        { (bayphone.state.name=="Signed") ?
                        <ButtonTooltip
                            title={t('View Terms File')}
                            style={{ marginLeft: 10, marginRight: 10 }}
                            cursor="pointer"
                            variant="outlined"
                            color="primary"
                            onClick={event => { event.stopPropagation(); generateToken({ variables: { resourceType: 'bayphone_terms', id: String(bayphone.id) } })}}
                        >
                            <DescriptionIcon style={{ marginTop: 10, color: 'primary', fontSize: '20px' }}/>
                        </ButtonTooltip>
                        : null
                        }
                    </div>
                </CardContent>
            </Card>
            <BayphoneAcceptTermsDialog
                open={openTermsDialog}
                onClose={onCloseTermsDialog}
                bayphone={bayphone}
                termsAccepted={termsAccepted}
                setTermsAccepted={setTermsAccepted}
                t={t}
                handleRefresh={handleRefresh}
            />
        </>
    )
}

export default ActiveBayphones